import { Mutation, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function mockedAddVisitorWithRoleData(addVisitor: Visitor): Pick<Mutation, 'addVisitor'> {
  return {
    addVisitor
  };
}

export const mockedAddVisitorWithRoleDataForMutation1 = mockedAddVisitorWithRoleData(
  generateMockVisitor({
    id: 'mockedVisitorIdExternalUserNew',
    name: 'mockedExternalUserName',
    email: 'mockedExternalUserEmail',
    isAdmin: false,
    visitorGroupMembership: []
  })
);

export const mockedAddVisitorWithRoleDataForMutation2 = mockedAddVisitorWithRoleData(
  generateMockVisitor({
    id: 'mockedVisitorIdExternalUserNew',
    name: 'mockedVisitorNameExternalUserNew',
    email: 'mockedVisitorEmailExternalUserNew',
    isAdmin: false,
    visitorGroupMembership: []
  })
);
